export interface CurrentUserIdentities {
    username?: string;
    email?: string;
    userId?: string;
}

export const isCurrentUser = (creationUser: string, user: CurrentUserIdentities) => {
    const normalizedCreationUser = creationUser.toLowerCase();

    return [user.username, user.email, user.userId]
        .filter((identity): identity is string => Boolean(identity))
        .some((identity) => identity.toLowerCase() === normalizedCreationUser);
};
